<template>
  <v-container>
    <h1 class="text-center">
      Страница кухни
    </h1>
    <v-row>
      <v-col cols="12" sm="4">
        <dish-card />
      </v-col>
      <v-col cols="12" sm="4">
        <dish-card />
      </v-col>
      <v-col cols="12" sm="4">
        <dish-card :timer="{}" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DishCard from '@/components/kitchen/dish-card/DishCard'

  export default {
    name: '',
    components: {
      DishCard,
    },
  }
</script>

<style lang="scss" scoped></style>
